import { Button, CurrencyInput, Grid, Input, Layout, Loader, NumericInput, Table, Typography } from "../../../components";
import { Paper } from "../../../components";
import { useFormik } from "formik";
import { COMPANY_OPTIONS } from "../../../constants";
import { CreateBidValidationSchema } from "@next-pontos/validations";
import { useAxios } from "../../../hooks";
import { useNavigate } from "react-router-dom";
import {useMemo, useEffect, Fragment} from 'react'
import { formatMoney } from "../../../utils";

export function NewBid () { 
    const [bid, createBid] = useAxios({
        url: '/bid',
        method: 'POST'
    }, {
        manual: true
    })

    const [dashboard] = useAxios(`/user/dashboard`)

    const navigate = useNavigate()

    const formik = useFormik({
        initialValues: {
            company: '',
            miles: '',
            price: '',
            pax: '',
        },
        onSubmit: async values => {
            await createBid({ data: values })
            navigate('/minhas-ofertas')
        },
        validateOnMount: true,
        validationSchema: CreateBidValidationSchema
    })

    const paxOptions = useMemo(() => {
        return COMPANY_OPTIONS.find(item => item.value === formik.values.company)?.pax_options || []
    }, [formik.values.company])

    useEffect(() => {
        if (paxOptions.length === 1) {
            formik.setFieldValue('pax', paxOptions[0].value)
        } else {
            formik.setFieldValue('pax', '')
        }
    }, [formik.values.company, paxOptions])

    const lastPricePerK = useMemo(() => {
        const recent = dashboard?.data?.last_seven_days_k_price?.[dashboard?.data?.last_seven_days_k_price?.length - 1]

        return recent?.[formik.values.company]
    }, [dashboard?.data?.last_seven_days_k_price, formik.values.company])
    
    return (
        <Layout>
            <Grid container justifyContent="center" minHeight={"calc(100vh - 64px)"} alignItems="center" padding={3} spacing={2}>
                {bid.loading || dashboard.loading ? (
                    <div style={{
                        display: 'flex',
                        flex: '1',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <Loader />
                    </div>
                ) : (
                    <Fragment>
                        <Grid item xs={12} sm={4}>
                            <Paper elevation={1}>
                                <form onSubmit={formik.handleSubmit}>
                                <Grid container padding={2} spacing={2} justifyContent="center">
                                    <Grid item xs={12} marginBottom={2}>
                                        <Typography textAlign={"center"} variant="h5">Nova Oferta</Typography>
                                    </Grid>
                                    <Grid item xs={12}> 
                                        <Input 
                                            label="Companhia"
                                            name="company"
                                            select
                                            options={COMPANY_OPTIONS}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.company}
                                            helperText={formik.touched.company && formik.errors.company}
                                            error={!!formik.touched.company && !!formik.errors.company}
                                        />
                                    </Grid>
                                    <Grid item xs={12}> 
                                        <NumericInput 
                                            label="Quantidade de Milhas"
                                            name="miles"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.miles}
                                            helperText={formik.touched.miles && formik.errors.miles}
                                            error={!!formik.touched.miles && !!formik.errors.miles}
                                        />
                                    </Grid>
                                    <Grid item xs={12}> 
                                        <CurrencyInput 
                                            label="Valor do Milheiro (R$)"
                                            name="price"
                                            onChangeValue={(_, originalValue) => {
                                                formik.setFieldValue('price', originalValue)
                                            }}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.price}
                                            helperText={(formik.touched.price && formik.errors.price) || (lastPricePerK > 0 ? `Valor sugerido ${formatMoney(lastPricePerK)}`: '')}
                                            error={!!formik.touched.price && !!formik.errors.price}
                                        />
                                    </Grid>
                                    <Grid item xs={12}> 
                                        <Input 
                                            label="Quantidade de CPFs"
                                            name="pax"
                                            select
                                            options={paxOptions}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.pax}
                                            helperText={formik.touched.pax && formik.errors.pax}
                                            error={!!formik.touched.pax && !!formik.errors.pax}
                                            disabled={paxOptions.length <= 1}
                                        />
                                    </Grid>
                                    <Grid item marginTop={2}>
                                        <Button disabled={!formik.isValid} type="submit">Criar Oferta</Button>
                                    </Grid>
                                </Grid>
                                </form>
                            </Paper>
                        </Grid>
                </Fragment>)}
            </Grid>
        </Layout>
    )
}